import React from "react";
import {Route, Routes} from "react-router-dom";
import Operations from "./Operations";
import OperationsDefaultPage from "./OperationsDefaultPage";
import OperationsSidebarWrapper from "./OperationsSidebar";
import SensorDeviationPage from "./sensorDeviation/SensorDeviationPage";

export default function CalculationsRouter() {
    return (
        <Operations>
            <OperationsSidebarWrapper />
            <Routes>
                <Route path="/" element={<OperationsDefaultPage/>}/>
                <Route path="/sensor-deviation" element={<SensorDeviationPage/>}/>
            </Routes>
        </Operations>
    );
}